import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ApiService } from '@env-lib/api/api.service'
import {
    UpdatesItem,
    UpdatesResponse,
} from '@platform-lib/updates/updates.model'
import { Observable, Subject, map } from 'rxjs'

@Injectable({
    providedIn: 'root',
})
export class UpdatesService {
    public triggerReload$ = new Subject()

    constructor(
        private http: HttpClient,
        private api: ApiService
    ) {}

    getUpdates(): Observable<UpdatesItem[]> {
        return this.http
            .get<UpdatesResponse>(`${this.api.notification.backendUrl}/updates`)
            .pipe(map((response) => response.updates))
    }

    createOrUpdateTraigoUpdateItem(updateItem: UpdatesItem) {
        const url = `${this.api.notification.backendUrl}/updates`
        const body = {
            ...updateItem,
        }

        return this.http.put(url, body, { observe: 'response' })
    }

    deleteTraigoUpdate(updateItemId: string) {
        const url = `${this.api.notification.backendUrl}/updates/${updateItemId}`
        return this.http.delete(url, { observe: 'response' })
    }
}
